import { Box, Slider, Typography, type SliderProps } from '@mui/material';
import { memo, useCallback } from 'react';

import type { ControlProps } from './SettingControl';

type T = ControlProps<number | null>;
export interface SliderControlProps
  extends T, Omit<SliderProps, keyof T | 'onChange'> {
  min?: number;
  max?: number;
  step?: number;
  type: 'slider';
  onChange?: (value: number) => void;
}

export const SliderControl = memo<Omit<SliderControlProps, 'type'>>(
  ({
    name,
    label,
    description,
    value,
    min = 0,
    max = 100,
    step = 1,
    onChange,
  }) => {
    const handleChange = useCallback(
      (_: Event, newValue: number | number[]) => {
        onChange?.(newValue as number);
      },
      [onChange],
    );

    return (
      <Box>
        <Typography gutterBottom>{label || name}</Typography>
        <Slider
          value={Number(value) || 0}
          onChange={handleChange}
          min={min}
          max={max}
          step={step}
          valueLabelDisplay="auto"
        />
        {description && (
          <Typography variant="caption" color="textSecondary">
            {description}
          </Typography>
        )}
      </Box>
    );
  },
);

SliderControl.displayName = 'SliderControl';
